import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// Public
export const createBooking = (payload) => api.post("/api/bookings", payload).then((r) => r.data);
export const fetchSlots = (date) => api.get(`/api/bookings/slots`, { params: { date } }).then((r) => r.data);

// Auth
export const login = (email, password) => api.post("/api/auth/login", { email, password }).then((r) => r.data);
export const logout = () => api.post("/api/auth/logout").then((r) => r.data);
export const me = () => api.get("/api/auth/me").then((r) => r.data);

// Admin
export const fetchBookings = () => api.get("/api/admin/bookings").then((r) => r.data);
export const updateBookingStatus = (id, status) => api.patch(`/api/admin/bookings/${id}`, { status }).then((r) => r.data);
export const deleteBooking = (id) => api.delete(`/api/admin/bookings/${id}`).then((r) => r.data);
export const fetchStats = () => api.get("/api/admin/stats").then((r) => r.data);
